import {reduxName} from './constants'

export const SET_LOADING: string = reduxName + '/SET_LOADING';
export const SET_TRANSLATIONS:string = reduxName + '/SET_TRANSLATIONS';